<section class="w-100" *ngIf="showList">
    <plex-title size="sm" titulo="Número y organización" *ngIf="carpetaEfectores?.length">
    </plex-title>
    <plex-wrapper class="w-100 align-items-center" *ngFor="let carpeta of carpetaEfectores">
        <div class="row">
            <plex-label class="col-10" size="md" icon="folder-account" type="info"
                        titulo="{{carpeta.nroCarpeta || '(Sin número asignado)'}}"
                        subtitulo="{{carpeta.organizacion.nombre}}">
            </plex-label>
            <plex-button class="col-2" size="sm"
                         *ngIf="idOrganizacion === carpeta.organizacion._id && !showEdit && autorizado" type="warning"
                         tooltipPosition="left" tooltip="Editar" icon="pencil" (click)="editar()"
                         class="d-flex align-self-center ml-2">
            </plex-button>
        </div>

        <form #carpetaEdit="ngForm" class="row ml-4"
              *ngIf="idOrganizacion === carpeta.organizacion._id && showEdit && autorizado">
            <div class="col-8">
                <plex-text label="Nuevo número de carpeta" name="nroCarpeta" [pattern]="patronValidoCarpeta"
                           [(ngModel)]="nuevoNroCarpeta" size="md">
                </plex-text>
            </div>
            <div class="col-4 align-self-center mt-3 pl-0">
                <plex-button *ngIf="idOrganizacion === carpeta.organizacion._id && showEdit" class="float-left"
                             type="danger" size="sm" tooltipPosition="left" tooltip="Cancelar edición" icon="close"
                             name="cerrar" (click)="cerrarEdicion()">
                </plex-button>
                <plex-button class="float-left ml-1" *ngIf="idOrganizacion === carpeta.organizacion._id && showEdit"
                             size="sm"
                             [disabled]="nroCarpetaOriginal === nuevoNroCarpeta || carpetaEdit.invalid || !nuevoNroCarpeta.length"
                             type="success" tooltipPosition="left" tooltip="Confirmar edición" icon="check"
                             name="guardar" (click)="guardarCarpetaPaciente()">
                </plex-button>
            </div>
        </form>
    </plex-wrapper>
</section>
<ng-container *ngIf="showNuevaCarpeta">
    <plex-title titulo="carpeta del paciente" size="sm" class="mt-2 mb-2">
        <plex-button *ngIf="editarCarpeta" type="success" size="sm" label="registrar nueva"
                     (click)="crearCarpetaPaciente()">
        </plex-button>
    </plex-title>
    <plex-badge *ngIf="showList" type="warning" size="block" class="my-4">
        número de carpeta inexistente en la organización actual
    </plex-badge>
</ng-container>
<plex-wrapper class="w-100" *ngIf="!showList">
    <plex-text label="Nuevo número de Carpeta" size="sm" name="nroCarpeta" [(ngModel)]="nuevoNroCarpeta">
    </plex-text>
    <plex-button size="sm" type="danger" tooltipPosition="left" tooltip="Cancelar" (click)="cancelar()" icon="close">
    </plex-button>
    <plex-button size="sm" type="success" tooltipPosition="left" tooltip="Confirmar"
                 (click)="guardarCarpetaPaciente(true)" icon="check" class="ml-2">
    </plex-button>
</plex-wrapper>